import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class BatchesGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Batch',
            ROUTE_PATH.batchesGrid,
            ROUTE_PATH.addBatches,
            true,
            true,
            8,
            false,
            true,
            ['batch_number'],
            true,
            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '', headers: []
            },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: false }
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const batchNumber = new Headers('Batch Number', 'batch_number', false, true, 'text');
        const batchesStart = new Headers('Batch Start', 'duration_start', false, true, 'text');
        const batchesEnd = new Headers('Batch End', 'duration_end', false, true, 'text');
        // const deleted = new Headers('', 'showDeleteIcon', false, false, 'text');
        headers.push(batchNumber);
        headers.push(batchesStart);
        headers.push(batchesEnd);
        // headers.push(deleted);

        return headers;
    }


}